import _ from 'lodash';

import { types as actionTypes } from './waiverWorkItemsActions';
import { Action } from '../../../types';
import { WaiverWorkItem } from '../../../../types/waiverWorkItem';

export type WaiverWorkItemsState = {
  loading: boolean;
  workItemsById: { [key: number]: WaiverWorkItem };
  error?: string;
};

const initialState: WaiverWorkItemsState = {
  loading: false,
  workItemsById: {},
};

const keyWorkItemsById = (
  workItems?: WaiverWorkItem[]
): { [key: number]: WaiverWorkItem } =>
  workItems ? _.keyBy(workItems, 'id') : {};

export default function reducer(
  state: WaiverWorkItemsState = initialState,
  action: Action<WaiverWorkItem[]>
): WaiverWorkItemsState {
  switch (action.type) {
    case actionTypes.LOAD_SUCCESS:
      return {
        ...state,
        workItemsById: keyWorkItemsById(action.response),
        loading: false,
      };
    case actionTypes.LOAD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error ? action.error.message : undefined,
      };
    case actionTypes.LOAD:
      return {
        ...state,
        workItemsById: {},
        loading: true,
      };
    case actionTypes.SYNC_SUCCESS:
      return {
        ...state,
        workItemsById: {
          ...state.workItemsById,
          ...keyWorkItemsById(action.response),
        },
        loading: false,
      };
    case actionTypes.SYNC_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error ? action.error.message : undefined,
      };
    case actionTypes.SYNC:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
}
